// extracted by mini-css-extract-plugin
export default {"container":"BlockText_container__yHLfJ","col":"BlockText_col__vcO0E","title":"BlockText_title__nHej2","blank":"BlockText_blank__476Bj","content":"BlockText_content__g+TTQ"};